var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
			'amt-box',
			'corner-round-sm',
			("amt-box-" + (_vm.maskStatus(_vm.totalMask, _vm.maskAmt[_vm.type])))
		]},[_c('p',{staticClass:"amt-box-title"},[_vm._v(" "+_vm._s(_vm.typeMap[_vm.type])+"口罩數量 ")]),_c('p',{staticClass:"amt-box-amt text-sm"},[_c('span',{staticClass:"amt-box-num text-bold title-pmr"},[_vm._v(" "+_vm._s(_vm.maskAmt[_vm.type])+" ")]),_vm._v(" 片 ")])])}
var staticRenderFns = []

export { render, staticRenderFns }